import { createAction, props } from '@ngrx/store';
import { ShoppingListItem, ShoppingListItemWithIngredient } from '../../../shared/models/shopping-list-item';
import { ShoppingListFilterMap } from './shopping-list.reducer';
import { QuotaInfo } from '../../../shared/models/quota-info.model';

// Load
export const loadShoppingListItems = createAction('[Shopping List] Load Items');
export const loadShoppingListItemsSuccess = createAction('[Shopping List] Load Items Success', props<{ items: ShoppingListItemWithIngredient[] }>());
export const loadShoppingListItemsFailure = createAction('[Shopping List] Load Items Failure', props<{ error: any }>());

export const loadShoppingListQuota = createAction('[Shopping List] Load Quota');
export const loadShoppingListQuotaSuccess = createAction(
  '[Shopping List] Load Quota Success',
  props<{ quota: QuotaInfo }>()
);
export const loadShoppingListQuotaFailure = createAction('[Shopping List] Load Quota Failure');

// Add
export const addShoppingListItem = createAction('[Shopping List] Add Item', props<{ item: Omit<ShoppingListItem, 'shopping_list_id'> }>());
export const addShoppingListItemSuccess = createAction('[Shopping List] Add Item Success', props<{ item: ShoppingListItemWithIngredient }>());
export const addShoppingListItemFailure = createAction('[Shopping List] Add Item Failure', props<{ error: any }>());

// Update
export const updateShoppingListItem = createAction('[Shopping List] Update Item', props<{ id: number, item: Partial<ShoppingListItem> }>());
export const updateShoppingListItemSuccess = createAction('[Shopping List] Update Item Success', props<{ item: ShoppingListItemWithIngredient }>());
export const updateShoppingListItemFailure = createAction('[Shopping List] Update Item Failure', props<{ error: any }>());

// Delete
export const deleteShoppingListItem = createAction('[Shopping List] Delete Item', props<{ id: number }>());
export const deleteShoppingListItemSuccess = createAction('[Shopping List] Delete Item Success', props<{ id: number }>());
export const deleteShoppingListItemFailure = createAction('[Shopping List] Delete Item Failure', props<{ error: any }>());

export const clearBoughtShoppingListItems = createAction('[Shopping List] Clear Bought Items');
export const clearBoughtShoppingListItemsSuccess = createAction('[Shopping List] Clear Bought Items Success');
export const clearBoughtShoppingListItemsFailure = createAction('[Shopping List] Clear Bought Items Failure', props<{ error: any }>());

// Reset
export const resetShoppingList = createAction('[Shopping List] Reset State');

// Filters
export const setShoppingListFilters = createAction(
    '[Shopping List] Set Filters',
    props<{ filters: ShoppingListFilterMap }>()
);
  
export const clearShoppingListFilters = createAction('[Shopping List] Clear Filters');
export const resetShoppingListFilters = createAction('[Shopping List] Reset Filters');
  
// Search
export const updateShoppingListSearchTerm = createAction(
    '[Shopping List] Update Search Term',
    props<{ term: string }>()
);
  
export const resetShoppingListSearchTerm = createAction('[Shopping List] Reset Search Term');

export const bulkAddShoppingListItems = createAction(
  '[Shopping List] Bulk Add Items',
  props<{ items: Omit<ShoppingListItem, 'shopping_list_id' | 'household_id' | 'user_id'>[] }>()
);
export const bulkAddShoppingListItemsSuccess = createAction(
  '[Shopping List] Bulk Add Items Success',
  props<{ items: ShoppingListItemWithIngredient[] }>()
);
export const bulkAddShoppingListItemsFailure = createAction(
  '[Shopping List] Bulk Add Items Failure',
  props<{ error: any }>()
);
